import { paddingMedium } from "src/styles/spacing";

export const FLOATING_SELECT_HORIZONTAL_MARGIN = paddingMedium;
